/**
 * Maps layout text-decoration style fields to CSS properties for React/MUI `sx`.
 */
export function getTextDecorationCssProps(
  style: Record<string, unknown>,
  renderScale = 1,
): Record<string, string | undefined> {
  const result: Record<string, string | undefined> = {};
  const line = style.textDecorationLine;
  if (line != null) {
    const normalized = String(line).trim();
    if (normalized.length > 0) {
      result.textDecorationLine = normalized;
    }
  }
  const color = style.textDecorationColor;
  if (color != null && String(color).trim().length > 0) {
    result.textDecorationColor = String(color);
  }
  const decorationStyle = style.textDecorationStyle;
  if (decorationStyle != null && String(decorationStyle).trim().length > 0) {
    result.textDecorationStyle = String(decorationStyle);
  }
  const thickness = style.textDecorationThickness;
  if (
    typeof thickness === "number" &&
    Number.isFinite(thickness) &&
    thickness > 0
  ) {
    result.textDecorationThickness = `${thickness * renderScale}px`;
  }
  return result;
}
